/**
 * @desc 修改驾驶员信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.ThePilotOfNewParameterObject): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/mall/driver/auditInfo',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
